import { motion } from 'motion/react'

import type { FC, PropsWithChildren } from 'react'

type Props = PropsWithChildren & {
  currentScreenIndex: number
}

export const AnimationWrapper: FC<Props> = ({
  children,
  currentScreenIndex,
}) => (
  <motion.div
    animate={{ opacity: 1 }}
    className="flex flex-col items-center"
    exit={{ opacity: 0 }}
    initial={{ opacity: 0 }}
    key={currentScreenIndex}
    transition={{ duration: 1 }}
  >
    {children}
  </motion.div>
)
